<template>
  <div class="main-content">
    <search-form ref="form" @search="handleSearch" :loading="searching"></search-form>

    <el-card v-loading="searching">
      <el-row class="search">
        <el-col :span="5">
          <el-button v-if="needCompanyInfo" type="primary" @click="handleToEdit">{{ $t('mv.create') }}</el-button>
        </el-col>
        <status-tabs class="right"></status-tabs>
      </el-row>

      <!-- 主内容区 -->
      <div class="mv-block">
        <div v-for="mv in tableData" :key="mv.mvId" class="mv-item">
          <!-- 封面图 -->
          <div class="mv-pic">
            <div class="mv-pic-item" :style="{backgroundImage:`url(${mv.mvPhotoList[0].url})`}" />
          </div>

          <svg-icon class="mv-status-icon" :icon-class="`${statusIconMap[mv.status]}-angle`"></svg-icon>
          <!-- <img v-if="mv.status" class="status-icon" :src="`/img/${statusIconMap[mv.status]}.png`"> -->
          <div class="mv-edit">
            <video-preview
              class="mv-preview"
              :url="mv.mvMedia.mediaUrl"
              :button-type="'success'"
              :button-text="$t('mv.preview')"
              icon="el-icon-video-play"
            ></video-preview>
            <el-button type="primary" icon="el-icon-edit" @click="handleToEdit(mv)">{{ $t('common.modify') }}</el-button>
          </div>
          <!-- <i class="el-icon-download" @click="handleDownload(album)" /> -->

          <div class="mv-info">
            <el-tooltip effect="dark" :content="mv.mvName" placement="top">
              <span class="mv-name" :title="mv.mvName">{{ $t('mv.mvName') }}： {{ mv.mvName }}</span>
            </el-tooltip>
            <el-tooltip effect="dark" placement="top" :content="mv.singerName">
              <span class="singer-name" :title="mv.singerName">{{ $t('common.singerName') }}：{{ mv.singerName }}</span>
            </el-tooltip>
            <span class="mv-publish-time">{{ $t('common.publicTime') }}：{{ mv.saleTime }}</span>
          </div>
        </div>
      </div>

      <Empty v-if="!tableData.length"></Empty>

      <el-pagination
        v-if="tableData.length > 10"
        @size-change="handleSearch"
        @current-change="fetchMv"
        :page-sizes="[12, 20, 50, 100, 1000]"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fileToFrontend } from '@/utils/objUtil'
import VideoPreview from '@/components/VideoPreview'
import mvService from '@/api/mv'
import { statusMap, statusIconMap } from './const.js'
import SearchForm from './components/SearchForm.vue'
import StatusTabs from '@/components/StatusTabs/index.vue'
import Empty from '@/components/Empty/index.vue'
import { ROLE_TYPE_ENUM } from '@/views/person/const'

export default {
  name: 'MvList',
  components: {
    VideoPreview,
    SearchForm,
    StatusTabs,
    Empty
  },
  data() {
    return {
      statusMap,
      statusIconMap,
      condition: {},
      searchForm: {
        status: 0,
        mvName__icontains: '',
        singerName: '',
        upc: '',
        publicTime: '',
        uploadTime: '',
        relateCompanyIdList: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 12,
        total: 0
      },
      loading: true,
      popVisible: false,
      searching: false,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'copyrightCompanyList'
    ]),
    /**
     * @returns {Boolean}
     */
    needCompanyInfo() {
      return this.userInfo.roleType === ROLE_TYPE_ENUM.COMPANY.code || this.userInfo.roleType === ROLE_TYPE_ENUM.OTHER.code
    },
  },
  mounted() {
    this.fetchMv()
  },
  methods: {
    async fetchMv() {
      const { pagination } = this
      const formData = this.$refs.form.getFormData()
      const searchData = {
        page: pagination.current - 1,
        num: pagination.size,
        orderObjList: ['mvId desc'],
        ...formData
      }

      this.searching = true
      try {
        const resp = await mvService.find(searchData)
        this.pagination.total = resp.total
        this.tableData = resp.list.map(item => {
          item.mvPhotoList = item.mvPhotoList.map(photo => fileToFrontend(photo))
          item.singerName = item.mvSingerList.map(singer => singer.singerName).join(',')
          return item
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: `获取视频数据异常（${error.message}）`,
          error
        })
      }

      this.searching = false
    },

    handleUpdateCondition() {
      this.popVisible = false

      this.condition = {
        ...this.searchForm
      }
      this.handleSearch()
    },

    handleRemoveCond(type) {
      this.condition[type] = ''
      this.searchForm[type] = ''
      this.handleSearch()
    },

    handleSearch() {
      this.pagination.current = 1

      this.fetchMv()
    },

    handleToEdit(mvObj) {
      const query = {}
      if (mvObj) {
        query.id = mvObj.mvId
      } else {
        if (!(this.copyrightCompanyList[0] && this.copyrightCompanyList[0].cpCompanyId)) {
          return this.$confirm('未填写版权所属厂牌，无法新增专辑！', '提示', {
            confirmButtonText: '去填写',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(_ => {
            this.$router.push({ name: 'personEdit' })
          }).catch(_ => {})
        }
      }

      this.$router.push({ name: 'mvEdit', query })
    },

    handleStatusChange() {
      this.handleSearch()
    },

  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

// .export-all {
//   position: absolute;
//   top: -35px;
//   right: 0;
// }

.el-card::v-deep {
  .el-card__body {
    padding: 20px;
    position: relative;
  }
}

.search {
  .el-radio {
    margin-right: 8px;

    &+.el-radio {
      border-left: 1px solid #ccc;
    }

    /deep/ .el-radio__input {
      display: none;
    }
  }
  .link {
    cursor: pointer;
  }
}
.condition-form {
  background-color: #f0f2f5;
  margin-top: 8px;

  .el-form-item {
    margin-bottom: 0;
  }
}
.search-form {
  .search-item {
    width: 190px;
  }
}
.status-icon {
  width: 20px;
  height: 20px;
  vertical-align: sub;
}

.mv-block {
  position: relative;
  display: flex;
  margin: 16px 0;
  flex-wrap: wrap;
  justify-content: flex-start;

  $border: 25px;
  .mv-status-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 56px;
    height: 56px;
    z-index: 1;

  }
  .el-icon-download {
    visibility: hidden;
    position: absolute;
    right: 5px;
    top: 175px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    font-size: 20px;
    color: $success;
    cursor: pointer;

    &:hover {
      background-color: #fff;
    }
  }

  .mv-item {
    position: relative;
    width: 228px;
    margin: 0 30px 30px 0;
    padding: 10px;
    border: 1px solid #e8e8e8;
    border-radius: 10px 10px 0 0;
    background-color: #E3E2EB;
    overflow: hidden;

    &:hover {
      box-shadow: 0 2px 8px rgba(0,0,0,.09);
      border-color: rgba(0,0,0,.09);

      .mv-pic {
        filter: blur(3px);
      }

      .mv-edit {
        // display: block;
        opacity: 1;
      }

      .el-icon-download {
        visibility: visible;
      }
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  .mv-edit {
    position: absolute;
    opacity: 0;
    left: 10px;
    top: 10px;
    width: 206px;
    height: 208px;
    line-height: 185px;
    background: rgba(0,0,0, .5);
    text-align: center;
    transition: opacity 0.3s ease-in-out;
  }
  .mv-preview {
    margin-right: 8px;
  }

  .mv-pic {
    display: block;
    border: none;
    border: none;
    border-bottom: 1px solid #e8e8e8;
    line-height: 200px;
    text-align: center;
    height: 208px;
    position: relative;

    .mv-pic-item {
      background-size: cover;
      background-position: center;
      position: relative;
      height: 208px;
      z-index: 1;
    }
  }
  .mv-info {
    display: flex;
    flex-direction: column;
    border: none;
    margin-top: 6px;

    .mv-publish-time {
      font-weight: 400;
    }

    >span {
      color: #002444;
      display: block;
      line-height: 1.5;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
      line-height: 20px;
      white-space: nowrap;
    }
  }
}

</style>
